import { graphql } from "@/graphql/generated";
import { RemoveMunicipalPropertyRegisterMutation, RemoveMunicipalPropertyRegisterMutationVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const REMOVE_MUNICIPAL_PROPERTY_REGISTER_MUTATION_DOCUMENT: TypedDocumentNode<RemoveMunicipalPropertyRegisterMutation, RemoveMunicipalPropertyRegisterMutationVariables> = graphql(/* GraphQL */ `
    mutation RemoveMunicipalPropertyRegister($input: RemoveMunicipalPropertyRegisterInput!) {
      removeMunicipalPropertyRegister(input: $input)
    }
  `);
